import React, { useCallback, useMemo, useState } from 'react';
import { Popup, TextInput, Button, Flex } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import S from './Autosuggest.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const EMPTY_ARR = [];
const {
  tIcon
} = I18N.ns('molten.dataViewers.aggregations.Autosuggest');
export default function Autosuggest(props) {
  const {
    options = [],
    value,
    onChange,
    eventData,
    onFetchOptions,
    className,
    ...rest
  } = props;
  const sVal = value || EMPTY_ARR;
  const [filterValue, setFilterValue] = useState('');
  const [isFocused, setIsFocused] = useState(false);
  const onFocus = useCallback(() => {
    setTimeout(() => {
      setIsFocused(true);
    }, 250);
  }, [setIsFocused]);
  const onBlur = useCallback(() => {
    setTimeout(() => {
      setIsFocused(false);
    }, 250);
  }, [setIsFocused]);
  const onSelect = useCallback(evt => {
    onChange({
      value: [...sVal, evt.value],
      data: eventData
    });
    setFilterValue('');
  }, [onChange, setFilterValue, sVal, eventData]);
  const onRemove = useCallback(evt => {
    onChange({
      value: sVal.filter(val => val !== evt.value),
      data: eventData
    });
  }, [onChange, eventData, sVal]);
  const unselectedOpts = useMemo(() => {
    return options.filter(option => {
      return !sVal.includes(option);
    });
  }, [options, sVal]);
  const opened = useMemo(() => {
    return unselectedOpts.length > 0 && isFocused && filterValue.length > 1;
  }, [options, isFocused, filterValue]);
  const onFilterChange = useCallback(evt => {
    setFilterValue(evt.value);
    if (onFetchOptions && typeof onFetchOptions === 'function') {
      onFetchOptions({
        value: evt.value
      });
    }
  }, [setFilterValue, onFetchOptions]);
  const onReturn = useCallback(evt => {
    if (evt.keyCode === 13 && filterValue.length > 0) {
      onChange({
        data: eventData,
        value: [...sVal, filterValue]
      });
      setFilterValue('');
    }
  }, [eventData, filterValue, sVal]);
  const renderTrigger = useCallback(({
    ref
  }) => {
    return /*#__PURE__*/_jsxs("div", {
      className: className,
      onFocus: onFocus,
      onBlur: onBlur,
      children: [/*#__PURE__*/_jsx("div", {
        className: S.tagHolder,
        children: sVal.map((item, index) => {
          return /*#__PURE__*/_jsx("div", {
            className: S.tag,
            style: {
              display: 'inline-block'
            },
            children: /*#__PURE__*/_jsxs(Flex, {
              align: "center",
              children: [item, /*#__PURE__*/_jsx(Button, {
                onClick: () => {
                  onRemove({
                    value: item,
                    data: index
                  });
                },
                variant: "tertiaryTinyIconic",
                icon: tIcon('closeIcon', 'fa fa-close fa-fw'),
                className: S.remove
              })]
            })
          }, item);
        })
      }), /*#__PURE__*/_jsx(TextInput, {
        domRef: ref,
        value: filterValue,
        changeOnReturn: false,
        alwaysFireOnReturn: false,
        onChange: onFilterChange,
        onKeyDown: onReturn,
        ...rest
      })]
    });
  }, [filterValue, sVal, onRemove, onFocus, onBlur, onFilterChange]);
  return /*#__PURE__*/_jsx(Popup, {
    trigger: renderTrigger,
    setPopupMinWidth: true,
    opened: opened,
    children: unselectedOpts.map(option => /*#__PURE__*/_jsx(Popup.Item, {
      value: option,
      eventData: eventData,
      onClick: onSelect,
      children: option
    }, option))
  });
}